import type { ResourceNote } from '@quromedical/models';
import { useCallback, useMemo } from 'react';
import { strings } from 'strings';
import { trpc } from 'trpc';

interface useClinicalSummaryProps {
  clinicalSummary: ResourceNote | undefined;
  isLoading: boolean;
  error: string | undefined;
  refetch: () => Promise<void>;
}

export const useClinicalSummary = (
  patientId: string,
  admissionId: string,
): useClinicalSummaryProps => {
  const {
    data,
    error: trpcError,
    isLoading,
    refetch,
    isFetching,
  } = trpc.patient.getClinicalSummary.useQuery(
    { id: patientId, admission: admissionId },
    {
      refetchOnWindowFocus: false,
    },
  );

  const refetchClinicalSummary = useCallback(async () => {
    await refetch();
  }, [refetch]);

  const clinicalSummary = useMemo(
    () => data as ResourceNote | undefined,
    [data],
  );
  const error = trpcError ? strings.GenericErrorMessage : undefined;
  const loading = isLoading || isFetching;

  return {
    clinicalSummary,
    isLoading: loading,
    error,
    refetch: refetchClinicalSummary,
  };
};
